export const getFileExtension = (fileName: string): string => {
  const fileExtension = fileName.substring(
    fileName.lastIndexOf(".") + 1,
    fileName.length
  );

  return fileExtension || fileName;
};
